export default "__VITE_ASSET__ByAEY7$3__"